import { RenderedDrawerRoute } from '@/features/navigation/drawer/types'

/**
 * Returns an opted-in route's destination when reselected from a different screen.
 * Other focused drawer items retain their existing behavior.
 */
export const getFocusedRouteResetPath = (
    { reselectHref }: Pick<RenderedDrawerRoute, 'reselectHref'>,
    pathname: string,
    focused: boolean
): RenderedDrawerRoute['reselectHref'] => {
    if (!focused || !reselectHref) return

    const destinationPath = typeof reselectHref === 'string' ? reselectHref : reselectHref.pathname

    if (pathname === destinationPath) return

    return reselectHref
}
